import React from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import Overlay from './ModalOverlay';
import ModalCard from './ModalCard';
import styles from './styles.module.css';
import * as constants from '../constants';

const Modal = ({ children, size, ...props }: any) => {
  return (
    <Overlay
      {...props}
      delayClose={0}
    >
      {
        (args?: any) => (
          <div className={cnames(styles.modal, styles[size])}>
            <ModalCard>
              { typeof children === 'function' ? children(args) : children }
            </ModalCard>
          </div>
        )
      }
    </Overlay>
  );
};

/* eslint-disable react/require-default-props */
(Modal as any).propTypes = {
  /**
    * The content of the Modal, typically one or more ModalBody
    */
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
  ]),

  /**
    * The width of the Modal container
    */
  size: PropTypes.oneOf([constants.SMALL, constants.MEDIUM, constants.LARGE]),
  /**
    * Called when the user dismisses the modal
    */
  onCloseRequested: PropTypes.func,
  /**
    * A title for screen readers to provide context about the Modal's contents / purpose.
    */
  accessibleTitle: PropTypes.string,
  /**
    * Use instead of trigger to control the Modal with external state
    */
  open: PropTypes.bool,
  /**
    * A render function. Provides an onClick handler so you can build a
    * trigger UI that will open the Modal when clicked.
    */
  trigger: PropTypes.func,
  /**
   * Allows clicks outside of the active Modal, which is disabled by default
   */
  allowClicksOutsideWhenActive: PropTypes.bool,
};
/* eslint-enable react/require-default-props */

(Modal as any).defaultProps = {
  children: null,
  size: constants.SMALL,
};

(Modal as any).displayName = 'Modal';

export default Modal;
